<template>
  <div>
    <!-- 标题 -->
    <div class="instance-title">
      <Breadcrumb>
        <BreadcrumbItem>智能监控实例</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instance-top">
      <Row :gutter="4">
        <Col span="4">
          <DatePicker
            type="date"
            :options="options"
            placeholder="请选择日期"
            v-model="timeType"
            @on-change="changeTimeType(timeType)"
            style="width:100%;"
          ></DatePicker>
        </Col>
        <Col span="2">
          <Button
            @click="returnGo"
            v-hasPermission="['aiMonitor:applicationSystemAlarm:return']"
            >返回</Button
          >
        </Col>
      </Row>
    </div>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="cpu" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="memory" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="networkOut" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="networkIn" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>

    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="DiskUsage" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import utils from "../../../utils/utils.js";
export default {
  name: "InstanceDetail",
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        }
      },
      timeType: "",
      // echarts实例
      chartCpu: "",
      chartMemory: "",
      chartNetworkOut: "",
      chartNetworkIn: "",
      DiskUsage: "",

      // 数组
      cpuUsage: [],
      cpuUsagePrediction: [],
      memoryUsage: [],
      memoryUsagePrediction: [],
      networkOutflow: [],
      networkOutflowPrediction: [],
      networkInflow: [],
      networkInflowPrediction: [],
      xaxisData: [],
      ReadIOPSData: [],
      ReadIOPSPredictionData: [],
      WriteIOPSData: [],
      WriteIOPSPredictionData: [],
      ReadThroughputData: [],
      ReadThroughputPredictionData: [],
      WriteThroughputData: [],
      WriteThroughputPredictionData: [],
      DiskUsageData: [],
      DiskUsagePredictionData: []
    };
  },
  mounted: function() {
    this.currentDay();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function() {
      self.chartCpu.resize();
      self.chartMemory.resize();
      self.chartNetworkOut.resize();
      self.chartNetworkIn.resize();
    });
  },
  methods: {
    // 默认显示当前日期
    currentDay: function() {
      const myDate = new Date();
      const year = myDate.getFullYear();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      this.timeType = `${year}/${month}/${day}`;
      this.checkApplicationDataPoint();
    },
    // 返回上一页
    returnGo: function() {
      window.history.go(-1);
    },
    /******************查询********************************/
    // 折线图
    checkApplicationDataPoint: function() {
      this.$api.aiForecastDataPoint
        .checkApplicationDataPointStatistics({
          moduleId: this.$route.query.diskId,
          timeHorizon: utils.methods.formatDate(this.timeType),
          moduleType: 2
        })
        .then(res => {
          if (res.data.xaxisData == undefined) {
            this.xaxisData = [];
          } else {
            this.xaxisData = res.data.xaxisData;
          }

          this.ReadIOPSData = res.data.readIOPSData;
          this.ReadIOPSPredictionData = res.data.readIOPSPredictionData;
          this.WriteIOPSData = res.data.writeIOPSData;
          this.WriteIOPSPredictionData = res.data.writeIOPSPredictionData;
          this.ReadThroughputData = res.data.readThroughputData;
          this.ReadThroughputPredictionData =
            res.data.readThroughputPredictionData;
          this.WriteThroughputData = res.data.writeThroughputData;
          this.WriteThroughputPredictionData =
            res.data.writeThroughputPredictionData;

          this.DiskUsageData = res.data.diskUsageData;
          this.DiskUsagePredictionData = res.data.diskUsagePredictionData;

          this.all();
        });
    },
    changeTimeType: function() {
      this.checkApplicationDataPoint();
    },
    /******************所有折线图********************************/
    all: function() {
      this.chartCpuLine();
      this.chartMemoryLine();
      this.chartNetworkOutLine();
      this.chartNetworkInLine();
      this.chartDiskUsageLine();
    },
    /*************折线图*****************************/
    // 读IOPS
    chartCpuLine: function() {
      this.chartCpu = this.$echarts.init(document.getElementById("cpu"));
      this.chartCpu.setOption({
        title: {
          text: "读IOPS",
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: ["读IOPS", "读IOPS预测值"]
        },
        series: [
          {
            name: "读IOPS",
            type: "line",
            data: this.ReadIOPSData,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          },
          {
            name: "读IOPS预测值",
            type: "line",
            data: this.ReadIOPSPredictionData,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 写IOPS
    chartMemoryLine: function() {
      this.chartMemory = this.$echarts.init(document.getElementById("memory"));
      this.chartMemory.setOption({
        title: {
          text: "写IOPS",
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: ["写IOPS", "写IOPS预测值"]
        },
        series: [
          {
            name: "写IOPS",
            type: "line",
            data: this.WriteIOPSData,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: "写IOPS预测值",
            type: "line",
            data: this.WriteIOPSPredictionData,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 读吞吐量
    chartNetworkOutLine: function() {
      this.chartNetworkOut = this.$echarts.init(
        document.getElementById("networkOut")
      );
      this.chartNetworkOut.setOption({
        title: {
          text: "读吞吐量",
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: ["读吞吐量", "预测读吞吐量"]
        },
        series: [
          {
            name: "读吞吐量",
            type: "line",
            data: this.ReadThroughputData,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: "预测读吞吐量",
            type: "line",
            data: this.ReadThroughputPredictionData,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 写吞吐量
    chartNetworkInLine: function() {
      this.chartNetworkIn = this.$echarts.init(
        document.getElementById("networkIn")
      );
      this.chartNetworkIn.setOption({
        title: {
          text: "写吞吐量",
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: ["写吞吐量", "预测写吞吐量"]
        },
        series: [
          {
            name: "写吞吐量",
            type: "line",
            data: this.WriteThroughputData,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: "预测写吞吐量",
            type: "line",
            data: this.WriteThroughputPredictionData,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 磁盘使用率
    chartDiskUsageLine: function() {
      this.DiskUsage = this.$echarts.init(document.getElementById("DiskUsage"));
      this.DiskUsage.setOption({
        title: {
          text: "磁盘使用率",
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: ["磁盘使用率", "预测磁盘使用率"]
        },
        series: [
          {
            name: "磁盘使用率",
            type: "line",
            data: this.DiskUsageData,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: "预测磁盘使用率",
            type: "line",
            data: this.DiskUsagePredictionData,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
.instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.instance-top {
  width: 100%;
  height: 53px;
  background-color: #fff;
  padding: 4px 0px 0px 0px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/ai_dashboard/VolumesDetail.vue